import { Flex, Select, SelectProps, Tag } from "antd";
import { useTranslation } from "react-i18next";

import { Product } from "@/types/product";
import SText from "@/styles/SText";
import { numFormmater } from "@/pages/Requirement/util";
import { OrderItemV2Ext } from "@/types/inventoryV2";
import { PackSourceItem, PackSourceItemLot } from "@/types/packing";
import { useMemo } from "react";

export const DEFAULT_EXT_KEY = "NULL";

interface SelectSourceItemLotProps extends SelectProps {
  list: Array<PackSourceItemLot>;
  onChangeLot?: (info: PackSourceItemLot) => void;
  extOptionData?: Record<string, number>;
}

const SelectSourceItemLot = ({
  list,
  onChangeLot,
  onChange,
  extOptionData,
  ...props
}: SelectSourceItemLotProps) => {
  const { t } = useTranslation();
  const options = useMemo(() => {
    return list.map(o => ({ ...o, disabled: (o.remainingCount ?? 0) <= 0 }))
  }, [list]);
  return (
    <Select
      onChange={(val, info) => {
        onChange?.(val, info);
        onChangeLot?.(info as PackSourceItemLot)
      }}
      optionRender={(info) => {
        let data: PackSourceItemLot = (info.data as PackSourceItemLot);
        return (
          <Flex gap={8}>
            <Tag color="green">{(info.data as PackSourceItemLot).lot}</Tag>
            <SText text={t('warehouse.remainPack') + ": " + numFormmater((data?.remainingCount ?? 0) + (extOptionData?.[data?.lot ?? DEFAULT_EXT_KEY] ?? 0))} />
          </Flex>
        )
      }}
      labelRender={(info) => {
        const data = options.find(d => d.lot === info.value);
        return data && (
          <Flex gap={8}>
            <Tag color="green">{data.lot}</Tag>
            <SText text={t('warehouse.remainPack') + ": " + numFormmater((data?.remainingCount ?? 0) + (extOptionData?.[data?.lot ?? DEFAULT_EXT_KEY] ?? 0))} />
          </Flex>
        )
      }}
      style={{ width: "100%" }}
      options={options}
      fieldNames={{ value: 'lot' }}
      showSearch
      filterOption={(input, option) =>
        (option?.lot ?? "").toLowerCase().includes(input.toLowerCase())
      }
      {...props}
    />
  );
};

export default SelectSourceItemLot;
